module.exports = {"home":"首页","about":"关于我们","contact":"联系我们","contactinfotop":"如果您对我们的游戏有任何疑问或建议，请随时与我们联系。","contactinfobottom":"客户服务：请联系：texasmasterxxx@gmail.com 品牌合作：请联系：texasmasterxxx@gmail.com 公关咨询：请联系：texasmasterinfo@gmail.com","company":"公司介绍","companyinfo":"在德州大师中，您可以自由定制属于您自己的德州扑克玩法，高自由度是我们的一大特色。在德州大师中，您可以与朋友一起定制您最喜欢的德州扑克俱乐部。我们拥有国际游戏实验室（GLI）认证的随机数生成器，配合我们专业的运营团队，确保游戏公平、有趣。","question":"如果您对我们的游戏有任何疑问或建议，请随时联系我们。客户服务：","pleasecontact":"请联系：","forbrandingcooperation":"品牌合作：","forpublicrelationshipenquiry":"公共关系查询：","title":"德州大师，专业精致的德州扑克！","welcometo":"欢迎来到德克萨斯大师"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/zn.json
// module id = lxVq
// module chunks = 16